const smoothScrollOptions = { behavior: 'smooth', block: 'center' };
const focusOptions = { preventScroll: true };
const maxFocusAttempts = 2;

const normalizeSelectors = (selectors) => {
  if (Array.isArray(selectors)) {
    return selectors.filter(Boolean);
  }

  return selectors ? [selectors] : [];
};

const deferToNextFrame = (callback) => {
  if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
    window.requestAnimationFrame(callback);
    return;
  }

  setTimeout(callback, 0);
};

export const getFirstInvalidField = (errors = {}, orderedFields = []) => (
  orderedFields.find((fieldName) => Boolean(errors?.[fieldName])) || null
);

const focusElement = (element) => {
  if (!element) {
    return;
  }

  if (typeof element.scrollIntoView === 'function') {
    element.scrollIntoView(smoothScrollOptions);
  }

  if (typeof element.focus === 'function') {
    element.focus(focusOptions);
  }
};

const queryTarget = (root, selectors) => {
  for (const selector of selectors) {
    const element = root.querySelector(selector);

    if (element) {
      return element;
    }
  }

  return null;
};

const focusFirstInvalidField = ({
  errors,
  orderedFields,
  selectorMap = {},
  root = document,
} = {}) => {
  if (!root || typeof root.querySelector !== 'function') {
    return null;
  }

  const firstInvalidField = getFirstInvalidField(errors, orderedFields);

  if (!firstInvalidField) {
    return null;
  }

  const selectors = [
    ...normalizeSelectors(selectorMap[firstInvalidField]),
    `#${firstInvalidField}`,
    `[name="${firstInvalidField}"]`,
  ];

  const attemptFocus = (attempt) => {
    const target = queryTarget(root, selectors);

    if (target) {
      focusElement(target);
      return;
    }

    if (attempt < maxFocusAttempts) {
      deferToNextFrame(() => attemptFocus(attempt + 1));
    }
  };

  deferToNextFrame(() => attemptFocus(1));

  return firstInvalidField;
};

export default focusFirstInvalidField;
